define('views/content/customer_settings',['require','backbone','views/components/customer_settings/company_settings','views/components/customer_settings/profile_settings','views/components/customer_settings/password_settings','models/customer','models/customer_manager','text!templates/content/customer_settings.html'],function(require){

    var Backbone = require('backbone');

    var CompanySettingsView = require('views/components/customer_settings/company_settings');
    var ProfileSettingsView = require('views/components/customer_settings/profile_settings');
    var PasswordSettingsView = require('views/components/customer_settings/password_settings');

    var CustomerModel = require('models/customer');
    var CustomerManagerModel = require('models/customer_manager');

    var temp = require("text!templates/content/customer_settings.html");
    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'settings-page page',
        titleKey: 'settings',

        initialize: function () {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        regions: function() {
            return {
                CompanySettingsContainer: ".company-settings",
                ProfileSettingsContainer: ".profile-settings",
                PasswordSettingsContainer: ".password-settings"
            };
        },

        onRender: function () {
            var _this = this;

            var customer = new CustomerModel({
                id: App.user.get('customer')
            });

            customer.fetch({
                success: function () {
                    _this.CompanySettingsContainer.show(new CompanySettingsView({
                        model: customer
                    }));
                }
            });

            var manager = new CustomerManagerModel({
                id: App.user.get('id')
            });

            manager.fetch({
                success: function () {
                    _this.ProfileSettingsContainer.show(new ProfileSettingsView({
                        model: manager
                    }));
                }
            });

            _this.PasswordSettingsContainer.show(new PasswordSettingsView());
        }
    });
});
